<template>
  <div class="spread" @contextmenu.prevent="blockRightButton">
    <CompHeader @close="close" />
    <div class="spread-header">
      <div class="lookmore-btn"  @click="toUserCenter">查看更多特权</div>
      <div class="header-content">
        <span>
          <img src="@/assets/images/spread/header-left.png" />
        </span>
        <div class="header-title" style="display: inline-block">
          <h1>纯净无广告</h1>
          <p>金山毒霸会员专享特权</p>
        </div>
        <span>
          <img src="@/assets/images/spread/header-right.png" />
        </span>
      </div>
    </div>
    <div class="spread-scroll">
      <TopPicList class="top-pic" :picList="picList" />
      <Pay class="pay-item-w" 
        @changePay="changePay" 
        @login="loginReport" 
        @paySuccess="$router.push('/')"
        @changeRenew="renewReport"
        @changePayType = "reportType"
        @toAliPay="reportToAliPay"
        @toXieyi="toXieyi"
        ref="payModule"
       />
      <SpreadItem class="item" v-for="(item, index) in spreadItem" :key="index" :imgPosition="item.position" :content="item" />
      <!-- <div class="to-top" @click="toTop">
        返回顶部
        <img src="@/assets/images/spread/top.png"  />
      </div> -->
    </div>
  </div>
</template>

<script>
import CompHeader from '@/layout/Header.vue'
import Pay from "@/components/common/commonPayModule.vue"
import TopPicList from '@/components/common/TopPicList'
import SpreadItem from '@/components/common/SpreadItem'
// import { clientReport, callClient } from "@/utils/client";
import spreadMixins from '@/mixins/spreadMixins'

export default {
  mixins: [spreadMixins],
  data () {
    return {
      picList: [
        {pic_url: require('@/assets/images/spread/1.png'), txt: '无广告弹窗'},
        {pic_url: require('@/assets/images/spread/2.png'), txt: '拦截恶意广告'},
        {pic_url: require('@/assets/images/spread/3.png'), txt: '浏览器上网保护'}
      ],
      spreadItem: [
        {title: '经常被广告打扰？', desc: '金山毒霸全站无广告，“广告净化”功能拦截恶意广告，保持清爽的电脑体验。', position: 'right', pic_url: require('./../assets/images/spread/item1.png')},
        {title: '浏览器主页总是被强制修改？', desc: '金山毒霸保护默认浏览器及主页不被恶意篡改，享受清新的上网环境。', position: 'left',  class: 'item2', pic_url: require('./../assets/images/spread/item2.png')}
      ]
    }
  },
  components: {
    CompHeader,
    Pay,
    SpreadItem,
    TopPicList
  }
}
</script>

<style lang="scss">
.spread {
  width: 702px;
  height: 742px;
  overflow: hidden;
  background: transparent;
  color: #333333;
  margin: 0 auto;
  position: relative;
  .page {
    height: 300px;
  }
  &-header {
    height: 121px;
    background: url(~@/assets/images/spread/header-bg.png) no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
  }
  .header-content {
    text-align: center;
    h1 {
      color: #794A07;
      font-size: 30px;
      font-weight: 400;
    }
    p {
      color: #9C7008;
      font-size: 16px;
    }
  }
  .header-title {
    margin: 0 10px;
  }
  .top-pic {
    margin-top: 38px;
  }
  
  .item2 {
    .desc {
      color: #7E8C9D;
    }
  }
  .pay-item-w {
    margin-bottom: 40px;
  }
}
.lookmore-btn {
  position: relative;
  left: 12px;
  top: 9px;
  z-index: 111;
  cursor: pointer;
  font-size: 12px;
  line-height: 28px;
  padding: 0 10px 0 25px;
  border-radius: 14px;
  
  display: inline-block;
  background: url(~@/assets/images/spread/left.png) no-repeat 8px center;
  background-color: #FEE277;
}
.lookmore-btn {
  -webkit-app-region: no-drag;
}
.spread-scroll {
  height: 620px;
  overflow: auto;
  // -ms-overflow-style: none;
}
</style>
